// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__3WO5P","info":"styles_info__1bByW","info_text":"styles_info_text__3b--q"};